<mat-toolbar class="topbar">
  <!-- --------------------------------------------------------------- -->
  <!-- Desktop Menu -->
  @if (showToggle) {
    <button
      mat-mini-fab
      color="inherit"
      (click)="toggleCollapsed.emit()"
      class="d-flex justify-content-center toggle-btn"
    >
      <img
        class="d-block toggle-icon"
        width="20"
        height="20"
        [src]="
          options.sidenavCollapsed
            ? '/assets/images/svgs/nav-open.svg'
            : '/assets/images/svgs/nav-close.svg'
        "
        [alt]="
          options.sidenavCollapsed ? 'Open navigation' : 'Close navigation'
        "
      />
    </button>
  }

  <!-- Mobile Menu -->
  @if (!showToggle) {
    <button
      mat-mini-fab
      color="inherit"
      (click)="toggleMobileNav.emit()"
      class="d-flex justify-content-center toggle-btn"
    >
      <img
        class="d-block toggle-icon"
        width="20"
        height="20"
        src="/assets/images/svgs/mobile-menu.svg"
        alt="Open mobile menu"
      />
    </button>
  }
  <!-- --------------------------------------------------------------- -->

  <!-- Mobile Menu -->
  <!-- <button mat-mini-fab color="inherit" (click)="toggleMobileFilterNav.emit()"
    class="d-flex d-lg-none justify-content-center">
    <i class="iconify icon-20 d-flex" data-icon="solar:widget-3-line-duotone"></i>
  </button> -->

  <div class="d-none">
    <!-- --------------------------------------------------------------- -->
    <!--  Links -->
    <!-- --------------------------------------------------------------- -->
    <button
      mat-mini-fab
      color="inherit"
      [matMenuTriggerFor]="appsmenu"
      aria-label="Notifications"
      class="d-flex justify-content-center"
    >
      <i
        class="iconify icon-20 d-flex"
        data-icon="solar:widget-3-line-duotone"
      ></i>
    </button>

    <mat-menu #appsmenu="matMenu" class="apps-dd cardWithShadow">
      <div class="row">
        <div class="col-sm-8">
          <div class="p-l-16 p-t-16">
            <div class="b-b-1">
              <div class="row">
                @for (appdd of apps; track appdd.title) {
                  <div class="col-6 text-hover-primary">
                    <a
                      [routerLink]="[appdd.link]"
                      class="d-flex align-items-center text-decoration-none m-b-20"
                    >
                      <span
                        class="text-{{ appdd.color }} bg-light-{{
                          appdd.color
                        }} rounded icon-40 d-flex align-items-center justify-content-center"
                      >
                        <span
                          class="iconify icon-20"
                          [attr.data-icon]="appdd.icon"
                        ></span>
                      </span>

                      <div class="m-l-16">
                        <h5
                          class="f-s-14 f-w-600 m-0 textprimary mat-subtitle-1 hover-text lh-sm"
                        >
                          {{ appdd.title }}
                        </h5>
                        <span class="text-muted f-s-12">{{
                          appdd.subtitle
                        }}</span>
                      </div>
                    </a>
                  </div>
                }
              </div>
            </div>
            <div class="row align-items-center p-y-16">
              <div class="col-8">
                <a
                  [routerLink]="['/theme-pages/faq']"
                  class="f-w-600 text-dark primary-hover-text text-decoration-none d-flex align-items-center"
                >
                  <i-tabler
                    name="help"
                    class="f-s-20 m-r-8 icon-18 d-flex"
                  ></i-tabler>
                  Frequently Asked Questions
                </a>
              </div>
              <div class="col-4">
                <div class="d-flex justify-content-end p-r-24">
                  <button mat-flat-button color="primary">Check</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-4 m-l--24">
          <div class="position-relative p-16 b-l-1 h-100">
            <h4 class="f-s-18 f-w-600 mat-subtitle-1 m-b-20">Quick Links</h4>
            @for (quicklink of quicklinks; track quicklink.title) {
              <div class="text-hover-primary m-b-16">
                <a
                  [routerLink]="[quicklink.link]"
                  class="primary-hover-text text-decoration-none text-dark f-w-600 d-block"
                  >{{ quicklink.title }}</a
                >
              </div>
            }
          </div>
        </div>
      </div>
    </mat-menu>
  </div>

  <!-- --------------------------------------------------------------- -->
  <!-- Exchange Rate Box -->
  <!-- --------------------------------------------------------------- -->

  <div class="fx-rate-card d-flex align-center gap-10 p-x-8 p-y-4 w-auto">
    <!-- Status -->
    <div class="fx-status d-flex align-center gap-4 p-x-8 p-y-2">
      <span class="status-dot"></span>
      <span class="status-text">Live</span>
    </div>

    <!-- Rates -->
    <div class="fx-content-viewport">
      <div class="fx-content d-flex align-center gap-10">
        <div class="fx-primary d-flex align-center gap-8">
          <span class="fx-label">RemitCircle FX Rate</span>

          <div class="fx-rate-chip p-x-8 p-y-4">
            <span class="d-flex align-items-center gap-4">
              1 {{ sellCurrency }} =
              <ng-container
                *ngIf="isLoadingExchangeRate; else userConversionRateReady"
              >
                <ngx-skeleton-loader
                  count="1"
                  animation="pulse"
                  [theme]="{
                    height: '9px',
                    width: '30px',
                    background: '#a1b8ef',
                    margin: '5px 0 0 0',
                    display: 'inline-block',
                  }"
                />
              </ng-container>
              <ng-template #userConversionRateReady>
                {{ userConversionRate | number: "1.2-2" }}
              </ng-template>
              {{ buyCurrency }}
            </span>
          </div>
        </div>

        <span class="fx-divider"></span>

        <!-- Hidden by default -->
        <div
          class="fx-secondary d-flex align-center gap-8"
          [class.open]="rateCardExpanded"
        >
          <span class="fx-label">Mid-Market Rate</span>

          <div class="fx-rate-chip p-x-8 p-y-4">
            <span
              >1 {{ sellCurrency }} = {{ midMarketRate | number: "1.2-2" }}
              {{ buyCurrency }}</span
            >
          </div>
        </div>
      </div>
    </div>

    <!-- Action -->
    <button
      class="fx-action"
      type="button"
      aria-label="Toggle rate"
      [class.expanded]="rateCardExpanded"
      (click)="toggleRateCard()"
    >
      <span class="chevron"></span>
    </button>
  </div>

  <span class="flex-1-auto"></span>

  <!-- --------------------------------------------------------------- -->
  <!--  Search -->
  <!-- --------------------------------------------------------------- -->
  <!-- <button mat-mini-fab color="inherit" (click)="openDialog()" class="d-flex justify-content-center">
    <i class="iconify icon-20 d-flex" data-icon="solar:magnifer-outline"></i>
  </button>

  <button mat-mini-fab color="inherit" aria-label="lightdark" class="d-flex justify-content-center" (click)="setDark()">
    <i-tabler class="d-flex icon-22" [name]="options.theme === 'dark'? 'sun': 'moon'"></i-tabler>
  </button> -->

  <!-- --------------------------------------------------------------- -->
  <!-- Inbox Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <!-- <button mat-mini-fab color="inherit" [matMenuTriggerFor]="inboxmenu" aria-label="Inbox"
    class="d-flex justify-content-center position-relative">
    <i class="iconify icon-20 d-flex" data-icon="solar:inbox-line-line-duotone"></i>
    <div class="notification bg-primary text-white rounded-circle f-s-10">3</div>
  </button>
  <mat-menu #inboxmenu="matMenu" class="topbar-dd cardWithShadow">
    <div class="d-flex align-items-center p-x-32 p-y-16">
      <h6 class="f-s-16 f-w-600 m-0 mat-subtitle-1">Inbox</h6>
      <span class="m-l-auto">
        <span class="bg-warning text-white p-x-8 p-y-4 f-w-500 rounded f-s-12">3 new</span>
      </span>
    </div>

    @for(inbox of inbox; track inbox.title) {
    <button mat-menu-item class="p-x-30 p-y-12">
      <div class="d-flex align-items-center">
        <span
          class="position-relative flex-shrink-0 rounded-circle icon-45 d-flex align-items-center justify-content-center">
          <img class="rounded-circle" [src]="inbox.imagePath" width="45" height="45" alt="users" />
          <div matBadge="" matBadgeOverlap="false"
            class="{{ inbox.bgcolor }} demo-section inbox-badge icon-10 rounded-circle"></div>
        </span>
        <div class="m-l-16 w-100">
          <div class="d-flex align-items-center justify-content-between w-100">
            <h5 class="f-s-14 m-0 mat-subtitle-1">
              {{ inbox.title }}
            </h5>
            <span class="d-block mat-body-1 f-s-12 m-l-auto">
              {{ inbox.time }}</span>
          </div>
          <span class="d-block text-truncate f-s-14 mat-body-1 w-75">{{
            inbox.subtitle
            }}</span>
        </div>
      </div>
    </button>
    }

    <div class="p-y-12 p-x-32">
      <button mat-stroked-button color="primary" class="w-100">
        See All Messages
      </button>
    </div>
  </mat-menu> -->

  <!--   <a href="#" class="f-s-13 f-w-400" style="color:#5A5A5A;">
    Feedback
  </a> -->
  <!-- --------------------------------------------------------------- -->
  <!-- Notification Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <!--  <button mat-mini-fab color="inherit" [matMenuTriggerFor]="notificationmenu" aria-label="Notifications"-->
  <!--    class="d-flex justify-content-center position-relative">-->
  <!--    &lt;!&ndash; <i class="iconify icon-20 d-flex" data-icon="solar:bell-bing-line-duotone"></i> &ndash;&gt;-->
  <!--    <img class="d-block" src="/assets/images/svgs/icon-bell.svg" />-->
  <!--    <div class="notification bg-error text-white rounded-circle f-s-10">5</div>-->
  <!--  </button>-->
  <mat-menu #notificationmenu="matMenu" class="topbar-dd cardWithShadow">
    <div class="d-flex align-items-center p-x-32 p-y-16">
      <h6 class="f-s-16 f-w-600 m-0 mat-subtitle-1">Notifications</h6>
      <span class="m-l-auto">
        <span class="bg-primary text-white p-x-8 p-y-4 f-w-500 rounded f-s-12"
          >5 new</span
        >
      </span>
    </div>

    @for (notification of notifications; track notification.title) {
      <button mat-menu-item class="p-x-30 p-y-12">
        <div class="d-flex align-items-center">
          <span
            class="flex-shrink-0 text-{{ notification.color }} bg-light-{{
              notification.color
            }} rounded-circle icon-48 d-flex align-items-center justify-content-center"
          >
            <i-tabler
              name="{{ notification.icon }}"
              class="icon-20 d-flex"
            ></i-tabler>
          </span>
          <div class="m-l-16 w-100">
            <div
              class="d-flex align-items-center justify-content-between w-100"
            >
              <h5 class="f-s-14 f-w-600 m-0 mat-subtitle-1">
                {{ notification.title }}
              </h5>
              <span class="d-block f-s-12 m-l-auto">
                {{ notification.time }}</span
              >
            </div>
            <span class="d-block text-truncate f-s-12 w-75">{{
              notification.subtitle
            }}</span>
          </div>
        </div>
      </button>
    }

    <div class="p-y-12 p-x-32">
      <button mat-stroked-button color="primary" class="w-100">
        See all notifications
      </button>
    </div>
  </mat-menu>

  <!-- --------------------------------------------------------------- -->
  <!-- langugage Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <!-- <button [matMenuTriggerFor]="flags" mat-mini-fab color="inherit">
    <img [src]="selectedLanguage.icon" class="rounded-circle object-cover icon-20" />
  </button>
  <mat-menu #flags="matMenu" class="cardWithShadow" xPosition="before">
    @for(lang of languages; track lang.icon) {
    <button mat-menu-item (click)="changeLanguage(lang)">
      <div class="d-flex align-items-center">
        <img [src]="lang.icon" class="rounded-circle object-cover m-r-8 icon-20" />
        <span class="mat-subtitle-1 f-s-14">{{ lang.language }}</span>
      </div>
    </button>
    }
  </mat-menu> -->

  <!-- --------------------------------------------------------------- -->
  <!-- profile Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <!-- <button mat-fab extended color="inherit" [matMenuTriggerFor]="profilemenu" aria-label="Notifications"
    class="d-flex justify-content-center profile-btn-dd">
    <div class="d-flex align-items-center gap-4">
      <img src="/assets/images/profile/user-1.jpg" class="rounded-circle object-cover icon-20 profile-dd" width="20" />
    </div>
    <label>ABC Company</label>
  </button>
  <mat-menu #profilemenu="matMenu" class="topbar-dd cardWithShadow">
    <div class="p-x-32 p-y-16">
      <div class="d-flex align-items-center p-b-24 b-b-1 m-t-16">
        <img src="/assets/images/profile/user-1.jpg" class="rounded-circle" width="56" />
        <div class="m-l-16">
          <h6 class="f-s-14 f-w-600 m-0 mat-subtitle-1 d-flex align-items-center">
            David McMichael
            <span class="f-s-14 d-block text-success m-l-4">Pro</span>
          </h6>
          <span> david&#64;wrappixel.com </span>
        </div>
      </div>
    </div>
    <div class="p-x-32 p-b-16">
      @for(profile of profiledd; track profile.title) {
      <a class="p-8 text-decoration-none d-block text-hover-primary" [routerLink]="[profile.link]">
        <div class="d-flex align-items-center">
          <h5 class="f-s-14 f-w-600 m-0 textprimary mat-subtitle-1 hover-text">
            {{ profile.title }}
          </h5>
          @if(profile.new) {
          <span class="bg-light-error text-error rounded-sm p-x-8 p-y-4 f-w-500 f-s-12 m-l-4">5</span>
          }
        </div>
      </a>
      }
    </div>
  </mat-menu> -->

  <a
    *ngIf="!isPlatformAdmin && (!isAffiliateManager || selectedCompany)"
    class="edf-guide-btn"
    [href]="edfGuideUrl"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="EDF guide (opens in a new tab)"
  >
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <path d="M14 2v6h6" />
      <path d="M8 9.5h2.5M8 13.5h8M8 17.5h8" />
    </svg>
    <span class="edf-guide-label">EDF guide</span>
    <mat-icon class="edf-guide-external" aria-hidden="true"
      >open_in_new</mat-icon
    >
  </a>

  <ng-container
    *ngIf="
      isLoadingCompanyList || isLoadingSelectedCompany;
      else showCompanyMenu
    "
  >
    <div class="d-flex align-items-center p-x-4 p-y-0 p-t-1 rounded-sm s-d">
      <ngx-skeleton-loader
        [theme]="{
          height: '20px',
          width: '20px',
          margin: '5px 5px 0 0',
          padding: '0',
        }"
        animation="pulse"
        appearance="circle"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        [theme]="{ height: '15px', width: '100px', margin: '0', padding: '0' }"
        animation="pulse"
      ></ngx-skeleton-loader>
    </div>
  </ng-container>
  <ng-template #showCompanyMenu>
    <!-- Regular company selector for non-affiliate managers or affiliate managers with companies -->
    <button
      *ngIf="
        !isPlatformAdmin &&
        (!isAffiliateManager || (isAffiliateManager && selectedCompany))
      "
      mat-fab
      extended
      color="inherit"
      [matMenuTriggerFor]="companyMenu"
      aria-label="Notifications"
      class="d-flex justify-content-center profile-btn-dd"
    >
      <div class="d-flex align-items-center gap-4">
        <img
          [src]="selectedCompanyLogo"
          class="rounded-circle object-cover icon-20"
        />
      </div>
      <label>
        {{
          selectedCompany != undefined
            ? selectedCompany.name == undefined || selectedCompany.name == ""
              ? "Unverified Company"
              : selectedCompany.name
            : ""
        }}
      </label>
    </button>

    <!-- Affiliate Manager without company -->
    <div
      *ngIf="isAffiliateManager && !selectedCompany && !isPlatformAdmin"
      class="d-flex align-items-center gap-4 affiliate-manager-header p-x-12 p-y-8"
    >
      <img
        src="/assets/images/profile/placeholder.png"
        class="rounded-circle object-cover icon-20"
      />
      <label class="f-s-14 f-w-500 text-primary">Affiliate Manager</label>
    </div>

    <!-- Platform admin without company context -->
    <button
      *ngIf="isPlatformAdmin"
      mat-fab
      extended
      color="inherit"
      [matMenuTriggerFor]="companyMenu"
      aria-label="Platform admin menu"
      class="d-flex justify-content-center profile-btn-dd"
    >
      <div class="d-flex align-items-center gap-4">
        <img
          src="/assets/images/profile/placeholder.png"
          class="rounded-circle object-cover icon-20"
        />
      </div>
      <label class="f-s-14 f-w-500 text-primary">Platform Admin</label>
    </button>
    <mat-menu #companyMenu="matMenu" class="company-menu">
      <div class="company-list" *ngIf="!isPlatformAdmin">
        <div class="menu-list">
          <label class="f-s-12 f-w-600 text-gray p-y-6 p-x-8 m-b-4 d-block"
            >Switch organization</label
          >
          <button
            class="m-b-4"
            mat-menu-item
            *ngFor="let item of companyList"
            (click)="onSelectItem(item)"
            [ngClass]="{ 'selected-company': isSelectedCompany(item) }"
          >
            <div class="d-flex align-items-center">
              <img
                [src]="onSelectedCompanyItemLogo(item)"
                class="rounded-circle icon-34"
              />
              <div class="profile-info p-l-12">
                <label
                  class="f-s-13 f-w-500 text-primary m-b-6 txh-sm cursor-pointer"
                  >{{
                    item.name == undefined || item.name == ""
                      ? "Unverified Company"
                      : item.name
                  }}</label
                >
                <p class="f-s-13 f-w-400 text-secondary m-0 email">
                  {{ item.emails.length > 0 ? item.emails[0] : "" }}
                </p>
              </div>
            </div>
          </button>
        </div>
        <a
          *ngIf="!isPlatformAdmin"
          href="/kyc-onboarding"
          target="_blank"
          class="d-flex align-items-center justify-content-center f-s-13 f-w-600 text-secondary add-new"
          ><img class="m-r-6" src="/assets/images/svgs/icon-plus.svg" />Add New
          Organization</a
        >
      </div>
      <a class="action-btn m-t-4 f-w-600 text-secondary" (click)="signOut()"
        ><img class="m-r-6" src="/assets/images/svgs/log-out.svg" />Sign Out</a
      >
    </mat-menu>
  </ng-template>
</mat-toolbar>
